.container {
  flex-grow: 1;
  max-width: 670px;
}

.verificationCard {
  margin: 18px var(--card-gutter-width);
}
